import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label?: string;
  helperText?: string;
  wrapperClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className = '', error, label, helperText, id, wrapperClassName, ...props }, ref) => {
  const inputId = id || (label ? `input-${label.toLowerCase().replace(/\s+/g, '-')}` : undefined);

  const baseClasses = [
    'w-full',
    'min-h-[40px]',
    'px-3',
    'py-2',
    'text-sm',
    'leading-normal',
    'align-middle',
    'rounded-md',
    'border-2',
    'border-gray-300',
    'appearance-none',
    'focus:ring-2',
    'focus:ring-blue-500',
    'focus:ring-offset-2',
    'focus:outline-none',
    'focus:border-blue-500',
    'focus:border-2',
    'bg-white',
    'transition-all',
    'duration-200',
    'placeholder:text-gray-400',
    'placeholder:text-sm',
    'disabled:bg-gray-100',
    'disabled:text-gray-500',
    'disabled:cursor-not-allowed',
    'disabled:opacity-60',
    'disabled:border-gray-200',
    error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'hover:border-gray-400',
  ].join(' ');

  return (
    <div className={`w-full flex flex-col gap-2 ${wrapperClassName ?? ''}`}>
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-gray-700"
        >
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        className={`${baseClasses} ${className}`}
        {...props}
      />
      {error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
      {helperText && !error && (
        <p className="text-sm text-gray-500">{helperText}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export { Input }; 